import { createApiRequest } from "../common";

/**
 * Calendar event in the shape the calendar UI consumes (not the raw Nylas
 * shape — backend translates Nylas's `when` discriminated union into a
 * date+startTime+endTime triple).
 */
export interface IntegrationCalendarEvent {
  id: string;
  title: string;
  date: string;
  startTime: string;
  endTime: string;
  timezone?: string;
  participants: string[];
  meetingLink?: string;
  description?: string;
  type: 'meeting' | 'contract' | 'deadline' | 'review';
}

export interface ListIntegrationCalendarEventsRequest {
  connectionId: string;
  calendarId?: string;
  /** ISO date string. Defaults to now. */
  timeMin?: string;
  /** ISO date string. Defaults to now + 30 days. */
  timeMax?: string;
  limit?: number;
}

export interface ListIntegrationCalendarEventsResponse {
  events: IntegrationCalendarEvent[];
}

/**
 * GET upcoming calendar events for a Nylas-connected user (Google Calendar
 * or Outlook). Backed by /integrations/nylas/calendars/events.
 */
export const listIntegrationCalendarEventsApi = async (
  request: ListIntegrationCalendarEventsRequest,
): Promise<ListIntegrationCalendarEventsResponse> => {
  const apiRequest = createApiRequest<ListIntegrationCalendarEventsResponse>(
    'post',
    '/integrations/nylas/calendars/events',
  );
  return apiRequest(request);
};
